module.exports = __webpack_public_path__ + "static/media/dottieGus38.84b16c37.png";